module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowledgments",
    attrs: {
      "id": "ack"
    }
  }, [_c('h1', {
    staticClass: "acknowledgments"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "acknowledgments"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780865477377_sofa.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Paul Mandelbaum and Laurie Winer were ideal readers for the whole and are okay poker players. Leo Braudy, Ken Cmiel, Jay Fliegelman, and Rob Latham helped materially and, I don’t know what you call it—spiritually, I guess. Jeffrey Charis-Carlson, Corey Creekmur, Kathleen Diffley, Loren Glass, Cody Lutz, Steve Molton, Angie Nepodal, Laura Rigal, Sean Scanlan, Harry Stecopoulos, Erica Still, Jeffrey Swenson, and Keith Wilhite read large chunks of it, and I thank them for their comments. On the way out the door, thank you to Brooks Landon and Ed Folsom. Melanie Jackson, thank you for everything, and Lorin Stein, you’re no slacker, far from it. Jesse and Yarrow: you’re my favorite daughters, and I love the way you work.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6941d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780865477377_epub_ack_r1.vue
// module id = 75
// module chunks = 0